/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=79b3ced0&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=79b3ced0&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b3ced0"],['__file',"library/components/VabColumnBar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79b3ced0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79b3ced0', __exports__)) {
    api.reload('79b3ced0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=79b3ced0&scoped=true&ts=true", () => {
    api.rerender('79b3ced0', render)
  })

}


export default __exports__